import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './editActionSchemaModal.view.html';
import angular from 'angular';
let EditActionSchemaModalComponent = class EditActionSchemaModalComponent {
    constructor() {
        //#endregion
        //#region Properties
        this.initialSchema = '';
        this.workingSchema = '';
        this.isInvalidSchema = false;
        this.hasChanges = false;
        this.onChangeSchema = ($schema) => {
            this.validateSchema($schema);
            if (!this.isInvalidSchema) {
                this.workingSchema = $schema;
            }
            this.hasChanges = $schema !== this.initialSchema;
        };
        this.validateSchema = (schema) => {
            try {
                JSON.parse(schema);
                this.isInvalidSchema = false;
            }
            catch (e) {
                this.isInvalidSchema = true;
            }
        };
    }
    //#endregion
    //#region Lifecycle Hooks
    $onInit() {
        this.workingSchema = this.getSchemaString(angular.copy(this.action.$inputSchema));
    }
    $onChanges(changes) {
        if (changes.action && changes.action.currentValue) {
            this.initialSchema = this.getSchemaString(angular.copy(this.action.$inputSchema));
            this.workingSchema = this.initialSchema;
            this.validateSchema(this.workingSchema);
        }
    }
    onSaveAction() {
        if (this.onSave) {
            this.action.$inputSchema = this.workingSchema ? JSON.parse(this.workingSchema) : {};
            this.onSave({ $action: this.action });
        }
        else {
            console.warn('onSave callback is not provided.');
        }
    }
    //#region Helper methods
    getSchemaString($inputSchema) {
        return JSON.stringify($inputSchema, null, 4);
    }
};
EditActionSchemaModalComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: template,
        bindings: {
            action: '<',
            onClose: '&',
            onSave: '&',
        },
    })
], EditActionSchemaModalComponent);
export { EditActionSchemaModalComponent };
